// extracted by mini-css-extract-plugin
export default {"back-button-container":"BackButton_back-button-container__++Ibt","back-button-span":"BackButton_back-button-span__LrGrP","back-button-icon":"BackButton_back-button-icon__gNJuC"};